import imgLogo from '../../assets/logo.png';

export default class ImageUtils {
  static getAppLogoUrl() {
    return imgLogo;
  }
}



// WEBPACK FOOTER //
// ./shared/utils/ImageUtils.js